<template>
  <section class="about__area pt-90 pb-150">
    <div class="container">
      <div class="row">
        <div class="col-12 mb-50 text-center">
          <h2 class="section__title" style="font-size: 30px; text-transform: uppercase">{{$t('about.fairtech')}}FAIR TECH Yagona Axborot Tizimi</h2>
        </div>
      </div>
      <div>
        <div>
          <b-modal id="modal-center" size="xl" centered>
            <img style="width:100%; cursor: pointer; object-fit: cover; border:1px solid rgba(128,128,128,0.25)" src="../../assets/img/fairtech1.png" alt="">
          </b-modal>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-7 col-12">
          <div class="about__thumb-wrapper">
            <div class="about__thumb">
              <img v-b-modal.modal-center style="width:685px; cursor: pointer; object-fit: cover; border:1px solid rgba(128,128,128,0.25)" src="../../assets/img/fairtech1.png" alt="">
            </div>
          </div>
        </div>
        <div class="col-lg-5 col-12">
          <div class="about__content pl-10 pr-10 pt-5">
            <div class="about__list mb-35">
              <p style="list-style-type: disc; font-size: 16px; font-weight: 500; color: #0e1133;">
                {{$t('about.fairtech1')}}
                <br>
                {{$t('about.fairtech2')}}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-50 mt-50">
        <div class="col-12">
          <div class="about__content pl-10 pr-10 pt-10">
            <div class="section__title-wrapper mb-25">
              <h2 class="section__title" style="font-size: 26px">{{$t('about.fairtech3')}}</h2>
            </div>
            <div class="about__list">
              <ul>
                <li><i class="icon_check"></i>{{$t('about.fairtech4')}}</li>
                <li><i class="icon_check"></i>{{$t('about.fairtech5')}}</li>
                <li><i class="icon_check"></i>{{$t('about.fairtech6')}}</li>
                <li><i class="icon_check"></i>{{$t('about.fairtech7')}}</li>
                <li><i class="icon_check"></i>{{$t('about.fairtech8')}}</li>
                <li><i class="icon_check"></i>{{$t('about.fairtech9')}}</li>
                <li><i class="icon_check"></i>{{$t('about.fairtech10')}}</li>
                <li><i class="icon_check"></i>{{$t('about.fairtech11')}}</li>
                <li><i class="icon_check"></i>{{$t('about.fairtech12')}}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name:'RaqamArea'
};
</script>